import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PixCheckoutPanel, PixPanelCourse } from "./PixCheckoutPanel";
import mercadoPagoLogo from "@/assets/mercadopago-logo.svg";
import { ShieldCheck, Lock } from "lucide-react";

interface PixCheckoutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  course: PixPanelCourse;
}

export function PixCheckoutDialog({ open, onOpenChange, course }: PixCheckoutDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto p-0">
        {/* MP-branded header */}
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-border bg-gradient-to-br from-[hsl(var(--accent)/0.08)] to-transparent">
          <div className="flex items-center gap-3">
            <img
              src={mercadoPagoLogo}
              alt="Mercado Pago"
              width={40}
              height={40}
              className="h-10 w-10 rounded-full"
              loading="lazy"
            />
            <div className="flex-1 min-w-0">
              <DialogTitle className="text-base font-semibold leading-tight">
                Pagar com Pix
              </DialogTitle>
              <p className="text-xs text-muted-foreground truncate">
                via Mercado Pago · {course.title}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 mt-3 text-[11px] text-muted-foreground">
            <span className="inline-flex items-center gap-1">
              <Lock className="h-3 w-3" /> Conexão segura
            </span>
            <span className="inline-flex items-center gap-1">
              <ShieldCheck className="h-3 w-3" /> Antifraude MP
            </span>
            <span className="ml-auto font-mono">BRL</span>
          </div>
        </DialogHeader>

        <div className="px-6 py-5">
          <PixCheckoutPanel course={course} embedded />
        </div>
      </DialogContent>
    </Dialog>
  );
}
